export const ADD_CITY = 'weather/ADD_CITY';
export const DELETE_CITY = 'weather/DELETE_CITY';
export const DRAG_CITY = 'weather/DRAG_CITY';
export const LOADING = 'weather/LOADING';
export const LOADED = 'weather/LOADED';
export const ERROR = 'weather/ERROR';
export const INIT = 'weather/INIT';
export const ADD_HOME_CITY = 'weather/ADD_HOME_CITY';
